import React from "react";
import { Controller } from "react-hook-form";

import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

const RadioGroupController = ({
  name,
  rules,
  options = [],
  control,
  ...props
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <RadioGroup {...field} {...props}>
          {options.map((option) => (
            <FormControlLabel
              label={option.label}
              value={option.value}
              control={
                <Radio
                  sx={{
                    "&.Mui-checked": {
                      color: "var(--red-color)",
                    },
                  }}
                />
              }
            />
          ))}
        </RadioGroup>
      )}
    />
  );
};

export default RadioGroupController;
